import { SocialActions } from '../constants/Social';

export function loadFbSdkAndUpdateLoginStatus() {
  return {
    type: SocialActions.LOAD_FB_SDK_AND_UPDATE_LOGIN_STATUS,
  };
}

export function loadFbSdkAndUpdatetokenValidity() {
  return {
    type: SocialActions.LOAD_FB_SDK_AND_UPDATE_TOKEN_VALIDITY,
  };
}

export function updateFacebookTokenValidity() {
  return {
    type: SocialActions.UPDATE_FACEBOOK_TOKEN_VALIDITY,
  };
}

export function setFacebookTokenValidity(listenerId, valid) {
  return {
    type: SocialActions.SET_FACEBOOK_TOKEN_VALIDITY,
    listenerId,
    valid,
  };
}

export function checkFacebookConnectStatus() {
  return {
    type: SocialActions.CHECK_FACEBOOK_CONNECT_STATUS,
  };
}

export function removeFacebookData() {
  return {
    type: SocialActions.REMOVE_FACEBOOK_DATA,
  };
}
